
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Trauma(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Trauma"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Trauma is the <b>response to a deeply distressing or disturbing event</b> that
                                    overwhelms an individual's ability to cope, causes feelings of helplessness,
                                    diminishes their sense of self and their ability to feel a full range of
                                    emotions and experiences. It does not discriminate and it is pervasive
                                    throughout the world.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Trauma/1.png")} alt="Trauma" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Trauma most often refers to:</b></p>
                                <p><a className='links' href='https://en.wikipedia.org/wiki/Major_trauma'>Major trauma</a> in physical medicine, severe physical injury caused by an external source</p>
                                <p><a className='links' href='https://en.wikipedia.org/wiki/Psychological_trauma'>Psychological trauma</a>, a type of damage to the psyche that occurs as a result of a
                                    severely distressing event</p>
                                <p>Traumatic <a className='links' href='https://en.wikipedia.org/wiki/Injury'>injury</a>, sudden physical injury caused by an external force, which does not rise
                                    to the level of major trauma</p>
                                <p>There are three main types of trauma: <b> Acute, Chronic, or Complex </b></p>
                                <p>Acute trauma results from a single incident.</p>
                                <p>Chronic trauma is repeated and prolonged such as domestic violence or abuse.</p>
                                <p>Complex trauma is exposure to varied and multiple traumatic events, often of an invasive,
                                    interpersonal nature.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Trauma">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Trauma;